module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ye-2289a38ef27f51f7e88a7791dd125021.svg";